<template>
    <div>
        <message-controller></message-controller>
        <navbar></navbar>
        <div class="container pt-4">
            <h1 class="title">
                Materiál na stěně
                <b-icon v-if="isEditable" class="clickable" icon="plus-square-fill" variant="info"
                        @click="addNewItem()"></b-icon>
                <b-icon v-else class="clickable" icon="arrow-clockwise" variant="info"
                        @click="loadData('true')"></b-icon>
            </h1>

            <table class="table">
                <tbody>
                <tr v-for="item in posts.records" v-bind:key="item.id" v-bind:class="{ 'unavailable': item.available !== 1 }">
                    <td>
                        <h3 class="item-wrap clickable" >
                            <div @click="openModal(item.id)">{{item.name}}</div>
                            <div>
                                {{item.quantity}}
                                <b-icon v-if="isEditable" class="clickable" icon="pencil-square" variant="info"
                                        @click="openModalEdit(item.id)"></b-icon>
                            </div>
                        </h3>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>

        <b-modal id="modal-wall-material-item" class="modal" hide-header >
            <div v-if="modalData" class="d-block">
                <h3 class="item-wrap">
                    {{modalData.name}}
                </h3>
                <p class="mt-3">
                    {{modalData.description}}
                </p>
                <label for="quantity" class="mb-0">Aktuální počet položek</label>
                <b-input-group  label-for="quantity"
                                label="Aktuální počet položek"
                                class="mb-3">
                    <b-form-input
                            id="comment"
                            v-model="newCommentLog"
                            type="text"
                            required
                            placeholder="Důvod změny"
                    ></b-form-input>
                    <b-form-input
                            id="quantity"
                            class="col-2"
                            v-model="modalData.quantity"
                            type="number"
                            min="0"
                            required
                    ></b-form-input>
                    <b-input-group-append>
                        <b-button variant="info" @click="changeItemCount(modalData.id)">Uložit</b-button>
                    </b-input-group-append>
                </b-input-group>

                <b-button v-b-toggle:my-collapse variant="info" size="sm">
                    Historie změn
                </b-button>
                <b-collapse id="my-collapse" class="mt-2">
                    <b-card>
                        <table class="history_list table">
                            <tr v-for="(historyItem,index) in modalData.history_of_changes" v-bind:key="'history'+index">
                                <td>
                                    <span class="history_list__row">
                                        <b>{{historyItem.user_name.name}}</b>
                                        <span class="table-date text-right">
                                            {{ historyItem.time.date | moment("H:mm DD/MM/YY") }}
                                            |
                                            <b>{{historyItem.quantity}}</b>
                                        </span>
                                    </span>
                                    <span class="history_list__row" v-if="historyItem.comment">{{historyItem.comment}}</span>
                                </td>
                            </tr>
                        </table>
                    </b-card>
                </b-collapse>
            </div>

            <template v-slot:modal-footer="">
                <b-button block @click="$bvModal.hide('modal-wall-material-item')">Zavřít</b-button>
            </template>
        </b-modal>

        <b-modal v-if="isEditable" id="modal-wall-material-item-edit" class="modal" hide-header >
            <div v-if="modalData" class="d-block">
                <h3 class="item-wrap">

                </h3>
                <b-form-group>
                    <label>Název</label>
                    <b-form-input
                            v-model="modalData.name"
                            type="text"
                            placeholder="Vypňte název položky"
                            @change="updateModalData()"
                    ></b-form-input>
                </b-form-group>
                <b-form-group>
                    <label>Popis</label>
                    <b-form-textarea
                            id="form-description"
                            v-model="modalData.description"
                            placeholder="Popis položky"
                            rows="3"
                            max-rows="6"
                            @change="updateModalData()"
                    ></b-form-textarea>
                </b-form-group>
                <b-form-group>
                    <label>Množství</label>
                    <b-form-input
                            v-model="modalData.quantity"
                            type="number"
                            placeholder="Počet položek"
                            @change="updateModalData()"
                    ></b-form-input>
                </b-form-group>

                <b-form-group class="text-left mt-5">
                    <b-button variant="danger" size="sm"  @click="deleteItem(modalData.id)">Smazat
                        <b-icon icon="trash-fill" ></b-icon>
                    </b-button>
                </b-form-group>
            </div>

            <template v-slot:modal-footer="">
                <b-button block @click="$bvModal.hide('modal-wall-material-item-edit')">Zavřít</b-button>
            </template>
        </b-modal>
    </div>
</template>

<script>

import axios from 'axios'
import Navbar from "../components/navbar";
import MessageController from "../components/message-controller";

export default {
    name: "material-climbing-wall",
    components: {MessageController, Navbar},
    data() {
        return {
            posts: [],
            modalData: Object,
            errors: [],
            changedModalId: null,
            newCommentLog: ''
        }
    },
    methods: {
        async changeItemCount(materialItemId) {

            let data = {
                quantity: this.modalData.quantity,
                comment: this.newCommentLog,
                id_material_climbing_wall: materialItemId,
            };

            try {
                await axios({
                    url: process.env.VUE_APP_SERVER+'material-climbing-wall/change-item-count.php',
                    headers: {
                        'content-type': 'application/x-www-form-urlencoded'
                    },
                    data: data,
                    method: 'PUT'
                });
                this.loadData();
                this.newCommentLog = '';
                this.$eventHub.$emit('openMessageController', 'success', 'Změněno');



            } catch (error) {
                this.loadData();
                console.log("error", error);
            }

        },
        async loadData() {
            try {
                const response_data = await axios({
                    url: process.env.VUE_APP_SERVER+'material-climbing-wall/list.php',
                    headers: {
                        'content-type': 'application/x-www-form-urlencoded',
                    },
                    method: 'GET'
                });

                this.posts = response_data.data;

                if (this.changedModalId) {
                    this.changeDataInModal(this.changedModalId);
                }


            } catch (error) {
                console.log("error", error);
                this.$store.dispatch('logout');
            }
        },

        async updateModalData() {
            try {
                await axios({
                    url: process.env.VUE_APP_SERVER+'material-climbing-wall/update-item.php',
                    headers: { 'content-type': 'application/x-www-form-urlencoded' },
                    data: this.modalData,
                    method: 'PUT'
                });
                this.loadData();
                this.$eventHub.$emit('openMessageController', 'success', 'Změna proběhla úspěšně');

            } catch (error) {
                this.loadData();
                console.log("error", error);
                this.$eventHub.$emit('openMessageController', 'error', 'Operace se nezdařila');
            }

        },

        async deleteItem(id) {
            if (confirm("Opravdu smazat?")) {
                try {
                    await axios({
                        url: process.env.VUE_APP_SERVER + 'material-climbing-wall/delete-item.php',
                        headers: {'content-type': 'application/x-www-form-urlencoded'},
                        data: {'id': id},
                        method: 'DELETE'
                    });

                    const index = this.posts.records.findIndex(posts => posts.id === id);
                    this.posts.records.splice(index, 1);

                    this.$bvModal.hide('modal-wall-material-item-edit');
                    this.loadData();
                    this.$eventHub.$emit('openMessageController', 'success', 'Položka byla smazána');

                } catch (error) {
                    this.loadData();
                    console.log("error", error);
                    this.$eventHub.$emit('openMessageController', 'error', 'Operace se nezdařila');
                }
            }
        },

        async addNewItem() {

            try {
                const response = await axios({
                    url: process.env.VUE_APP_SERVER+'material-climbing-wall/new-item.php',
                    headers: { 'content-type': 'application/x-www-form-urlencoded' },
                    method: 'POST'
                });

                // data se načítají ve špatnou chvíli.
                this.loadData();
                this.openModalEdit(response.data.id, true);


            } catch (error) {
                this.loadData();
                console.log("error", error);
            }

        },

        openModal(itemId) {
            this.changedModalId = itemId;
            this.$bvModal.show('modal-wall-material-item'); // open bs modal
            this.changeDataInModal(itemId);


        },
        openModalEdit(itemId) {
            this.changedModalId = itemId;
            this.$bvModal.show('modal-wall-material-item-edit'); // open bs modal
            this.changeDataInModal(itemId);


        },
        changeDataInModal(itemId) {
            try {
                this.modalData = this.posts.records.find( ({ id }) => id === itemId );
            } catch(err) {
                console.log(err);
            }
        },
    },
    computed : {
        isEditable : function () { return (this.$route.params.action === 'edit' && this.$store.getters.isAdmin) }
    },
    created() {
        this.loadData();
    }
}
</script>

<style scoped lang="scss">
    .table {
        max-width: 100%;
        th, td {
            padding-left: 0;
            padding-right: 0;
        }
    }

    h3.item-wrap {
        color: var(--cyan);
        display: flex;
        align-items: flex-start;
        justify-content: space-between;

    }
    .description {
        color: #6c757d;
        line-height: 100%;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        overflow: hidden;

    }

    .icons {
        font-size: 1.5rem;
        float: right;
        cursor: pointer;
    }

    .badge {
        letter-spacing: .5px;
        font-weight: 500;
        vertical-align: middle;
    }


    .card-body {
        overflow: auto;
        max-height: 300px;
    }


    .title {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .history_list {
        padding: 0;
        margin: 0;
        td {
            color: var(--gray);
            vertical-align: top;
            display: flex;
            flex-direction: column;
        }
        .table-date {
            white-space: nowrap;
        }
        &__row {
            width: 100%;
            flex: 1 0 100%;
            display: flex;
            justify-content: space-between;
        }
    }
</style>
